/* unplugin-vue-components disabled */import { render } from "./Main.vue?vue&type=template&id=aca11d4c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=aca11d4c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Main.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca11d4c"]])

export default __exports__